'use client';

import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useLanguage } from '@/hooks/use-language';
import { useToOldStuCenter } from '@/hooks/use-to-old-stu-center';
import { useTraceCommonParams } from '@/hooks/use-trace-common-params';
import { homeEntryAtom } from '@/store/renewal-store';
import { isEmpty } from '@/utils/object';

export default function RenewalButton() {
  const { currentLanguage } = useLanguage();
  const { traceWithCommonParams } = useTraceCommonParams();
  const { getPathWithoutLanguage } = useLanguage();
  const homeEntry = useAtomValue(homeEntryAtom);
  const { toOldStuCenter } = useToOldStuCenter();

  // 定义要显示组件的路由
  const showOnRoutes = ['/home'];
  const showComponent = showOnRoutes.includes(getPathWithoutLanguage());

  useEffect(() => {
    const data = homeEntry?.normalEntry;
    if (!isEmpty(data) && showComponent) {
      const eventData = {
        _event: 'E_MKActivity_Entrance',
        activityConfig: {
          activityEnName: data?.activityEnName || '',
          activityZhName: data?.activityZhName || '',
          activityId: data?.activityId || '',
          startTime: data?.startTime || '',
          expireTime: data?.expireTime || '',
          activityType: data?.activityType || '',
          activityStatus: data?.activityStatus || '',
          subject: data?.subjects || '',
        },
        dsSource: 'Header',
      };
      traceWithCommonParams(eventData as any);
    }
  }, [homeEntry?.normalEntry, showComponent]);

  if (isEmpty(homeEntry?.normalEntry)) {
    return null;
  }

  if (!showComponent) {
    return null;
  }

  return (
    <button
      className="flex h-[32px] cursor-pointer items-center justify-center rounded-[50px] border-transparent bg-[#CD292A] px-[12px] text-[14px] font-extrabold leading-normal text-white"
      onClick={() => {
        const data = homeEntry?.normalEntry;
        const eventData = {
          _event: 'C_MKActivity_Entrance',
          activityConfig: {
            activityEnName: data?.activityEnName || '',
            activityZhName: data?.activityZhName || '',
            activityId: data?.activityId || '',
            startTime: data?.startTime || '',
            expireTime: data?.expireTime || '',
            activityType: data?.activityType || '',
            activityStatus: data?.activityStatus || '',
            subject: data?.subjects || '',
          },
          dsSource: 'Header',
        };
        traceWithCommonParams(eventData as any);
        toOldStuCenter(
          `/${currentLanguage}/home/renewalCourses?activityId=${homeEntry?.normalEntry?.activityId}`,
        );
      }}>
      <svg
        className="mr-[4px]"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none">
        <path
          d="M7.76074 0.623535C8.83274 0.567535 9.8816 0.97584 10.6416 1.73584L14.2734 5.35205C15.7613 6.84806 15.7614 9.2645 14.2734 10.7524L10.7607 14.2642C9.26477 15.7518 6.84924 15.7519 5.36133 14.2642L1.7373 10.6401C0.977413 9.88025 0.569324 8.83228 0.617188 7.75244L0.80957 3.75244C0.889563 2.16058 2.16095 0.888128 3.76074 0.815918L7.76074 0.623535ZM12.4268 8.37549C12.1947 8.14416 11.8109 8.14382 11.5791 8.37549L8.37891 11.5757C8.14731 11.8075 8.1476 12.1913 8.37891 12.4233C8.49869 12.5431 8.65101 12.5999 8.80273 12.6001C8.95468 12.6001 9.10756 12.5433 9.22754 12.4233L12.4268 9.22412C12.6588 8.99212 12.6588 8.60749 12.4268 8.37549ZM6.00293 3.6958C4.73088 3.69606 3.69953 4.72747 3.69922 5.99951C3.69922 7.27181 4.73069 8.30394 6.00293 8.3042C7.27535 8.30414 8.30664 7.27194 8.30664 5.99951C8.30633 4.72734 7.27516 3.69586 6.00293 3.6958Z"
          fill="#FFE395"
        />
      </svg>
      {currentLanguage === 'zh' ? '优惠' : 'Specials'}
    </button>
  );
}
